import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  timeAlert = 5000;

  private swalInstance: any = null;

  private async getSwal(): Promise<any> {
    if (!this.swalInstance) {
      this.swalInstance = (await import('sweetalert2')).default;
    }
    return this.swalInstance;
  }

  async alert(type: 'error' | 'success' | 'warning', content: string, showCloseButton: boolean = false, time?) {
    const Swal = await this.getSwal();
    if (type == 'error') {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `${content}`,
        html: content,
        timer: this.timeAlert,
        showCloseButton: showCloseButton
      })
    } else if (type == 'success') {
      Swal.fire({
        icon: 'success',
        title: 'Éxito',
        text: `${content}`,
        html: content,
        timer: time ? time : this.timeAlert
      })
    } else {
      Swal.fire({
        icon: 'warning',
        title: 'Advertencia',
        text: `${content}`,
        timer: this.timeAlert
      })
    }
  }

  async confirm(
    title: string,
    message: string,
    confirmButtonText: string = 'Sí',
    cancelButtonText: string = 'No'
  ): Promise<boolean> {
    const Swal = await this.getSwal();
    return Swal.fire({
      title: title,
      text: message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: confirmButtonText,
      cancelButtonText: cancelButtonText,
      reverseButtons: true
    }).then((result) => {
      return result.isConfirmed;
    });
  }

  async notification(
    message: string,
    confirmButtonText: string = 'Aceptar',
    cancelButtonText: string = 'No acepto',
    confirmButtonColor?: string
  ): Promise<boolean> {
    const Swal = await this.getSwal();
    return Swal.fire({
      title: 'Notificación',
      html: message,
      icon: 'info',
      confirmButtonText: confirmButtonText,
      showCancelButton: true,
      cancelButtonText: cancelButtonText,
      confirmButtonColor: confirmButtonColor
    }).then((result) => {
      return result.isConfirmed;
    });
  }


}
